module.exports = __webpack_public_path__ + "img/pay-wechat.8722afdc.png";